// Plate catalog.
// nameColor = the embroidery color of the personalized name, matched to each plate
//   (taken from the finished product photos / source SVG fills).
// geom = where the name sits over the artwork: cx/cy is the center as % of the box.
// handle = the Shopify product handle this plate maps to (used by the storefront
//   customizer to pick the right design for a product tagged "license plate").
const PLATES = [
  {
    id: "arizona",
    label: "Arizona",
    tagline: "Grand Canyon State",
    handle: "copper-state-arizona-license-plate-headcover",
    svg: "assets/plates/Arizona_License_Plate_0526.svg",
    nameColor: "#ffffff",
    geom: { cx: 45, cy: 51 },
  },
  {
    id: "cali-black",
    label: "California — Black",
    tagline: "Golden State",
    handle: "golden-state-california-license-plate-headcover",
    svg: "assets/plates/Cali__Black__License_Plate_0526.svg",
    nameColor: "#ffd41a",
    geom: { cx: 44, cy: 51 },
  },
  {
    id: "cali-white",
    label: "California — White",
    tagline: "Golden State",
    handle: "pacific-signature-california-license-plate-headcover",
    svg: "assets/plates/Cali__White__License_Plate_0526.svg",
    nameColor: "#26405e",
    geom: { cx: 44, cy: 51 },
  },
  {
    id: "florida",
    label: "Florida",
    tagline: "Sunshine State",
    handle: "sunshine-state-florida-license-plate-headcover",
    svg: "assets/plates/Florida_License_Plate_0526.svg",
    nameColor: "#1a6b3c",
    geom: { cx: 45, cy: 51 },
  },
  {
    id: "georgia",
    label: "Georgia",
    tagline: "Peach State",
    handle: "peach-state-georgia-license-plate-headcover",
    svg: "assets/plates/Georgia_License_Plate_0526.svg",
    nameColor: "#1a1a1a",
    geom: { cx: 45, cy: 51 },
  },
  {
    id: "illinois",
    label: "Illinois",
    tagline: "Land of Lincoln",
    handle: "the-lincoln-illinois-license-plate-headcover",
    svg: "assets/plates/Illinois_License_Plate_0526.svg",
    nameColor: "#23425c",
    geom: { cx: 45, cy: 51 },
  },
  {
    id: "ny-white",
    label: "New York — White",
    tagline: "Empire State",
    handle: "lady-liberty-new-york-license-plate-headcover",
    svg: "assets/plates/New_York__White__License_Plate_0526.svg",
    nameColor: "#23425c",
    geom: { cx: 44, cy: 51 },
  },
  {
    id: "ny-yellow",
    label: "New York — Yellow",
    tagline: "Empire State",
    handle: "empire-state-new-york-license-plate-headcover",
    svg: "assets/plates/New_York__Yellow__License_Plate_0526.svg",
    nameColor: "#1f2d3a",
    geom: { cx: 44, cy: 51 },
  },
  {
    id: "nova-scotia",
    label: "Nova Scotia",
    tagline: "Canada's Ocean Playground",
    handle: "the-bluenose-nova-scotia-license-plate-headcover",
    svg: "assets/plates/Nova_Scotia_License_Plate_0526.svg",
    nameColor: "#244990",
    geom: { cx: 44, cy: 51 },
  },
  {
    id: "ontario",
    label: "Ontario",
    tagline: "Yours to Discover",
    handle: "yours-to-drive-ontario-license-plate-headcover",
    svg: "assets/plates/Ontario_License_Plate_0526.svg",
    nameColor: "#345fa2",
    geom: { cx: 45, cy: 50 },
  },
  {
    id: "texas",
    label: "Texas",
    tagline: "The Lone Star State",
    handle: "the-lone-star-texas-license-plate-headcover",
    svg: "assets/plates/Texas_License_Plate_0526.svg",
    nameColor: "#232627",
    geom: { cx: 45, cy: 51 },
  },
];
